import CircleIcon from '@mui/icons-material/Lens';
import { Popover, styled, TextField } from '@mui/material';
import InputAdornment from '@mui/material/InputAdornment';
import type { SxProps } from '@mui/system';
import { Box } from '@mui/system';
import { memo, useState } from 'react';
import { ChromePicker } from 'react-color';

const StyChromePicker = styled(ChromePicker, {
    name: 'StyChromePicker',
})(() => ({
    boxShadow: 'none !important',
}));

type Props = {
    value?: string;
    setValue: (value: string) => void;
    label: string | null;
    sx?: SxProps;
    error?: string;
};

const ColorPicker = ({ value, setValue, label, sx, error }: Props) => {
    const [anchorEl, setAnchorEl] = useState<SVGSVGElement | null>(null);
    const open = Boolean(anchorEl);
    const handleClick = (
        event: React.MouseEvent<SVGSVGElement, MouseEvent>,
    ) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const id = open ? 'simple-popover' : undefined;
    return (
        <Box sx={sx}>
            <TextField
                value={value}
                onChange={(e) => setValue(e.target.value)}
                variant="outlined"
                label={label}
                error={!!error}
                helperText={error}
                slotProps={{
                    input: {
                        startAdornment: (
                            <InputAdornment position="start">
                                <CircleIcon
                                    sx={{ color: value }}
                                    onClick={handleClick}
                                />
                            </InputAdornment>
                        ),
                    },
                }}
            />
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
            >
                <StyChromePicker
                    color={value}
                    disableAlpha
                    onChange={(color) => setValue(color.hex)}
                />
            </Popover>
        </Box>
    );
};

export default memo(ColorPicker);
